import React, { useEffect, useState } from 'react';
import { Grid, Card, CardContent, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ScatterPlot from '../Charts/ScatterPlot'; // Scatter plot component
import PieChartByType from '../Charts/PieChartByType'; // Pie chart component
import { getEntityIncidents, getTrafficCameras, getCrashData } from '../../api';

const Dashboard = () => {
  const [latestIncidents, setLatestIncidents] = useState([]);
  const [topAssets, setTopAssets] = useState([]);
  const [latestAccidents, setLatestAccidents] = useState([]);
  const [incidentChartData, setIncidentChartData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const [incidents, trafficCameras, crashData] = await Promise.all([
        getEntityIncidents({ limit: 5 }),
        getTrafficCameras({ limit: 5 }),
        getCrashData({ limit: 5 }),
      ]);

      setLatestIncidents(incidents.data.data.map(item => ({
        id: item._id,
        time: item.updatedAt,
        source: item.sourceType,
        event: item.trigger.name,
      })));

 
      const chartData = await getEntityIncidents({limit : 100});
      setIncidentChartData(chartData.data.data.map(item => ({
        date: new Date(item.updatedAt).toISOString().split('T')[0],
        time: new Date(item.updatedAt).toISOString().split('T')[1].slice(0, 5),
        type: item.trigger.name,
      })));
    };

    fetchData();
  }, []);

  return (
    <Grid container spacing={3} style={{ padding: '20px' }}>

      {/* Incident Chart */}
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6">Incident Scatter Plot (Last 24 Hours)</Typography>
            <ScatterPlot data={incidentChartData} />
          </CardContent>
        </Card>
      </Grid>

      {/* Incident Pie Chart */}
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6">Incident Distribution by Type</Typography>
            <PieChartByType data={incidentChartData} />
          </CardContent>
        </Card>
      </Grid>
      {/* Latest 5 Incidents */}
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6">Latest 5 Incidents</Typography>
            <Grid container spacing={2}>
              {latestIncidents.map((incident, index) => (
                <Grid item xs={6} key={index}>
                  <Card>
                    <CardContent>
                      <Typography variant="body2">{`Time: ${new Date(incident.time).toLocaleString()}`}</Typography>
                      <Typography variant="body2">{`Source: ${incident.source}`}</Typography>
                      <Typography variant="body2">{`Workflow: ${incident.workflow}`}</Typography>
                      <Typography variant="body2">{`Event: ${incident.event}`}</Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => navigate(`/incident/${incident.id}`)}
                      >
                        View Details
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      
    </Grid>
  );
};

export default Dashboard;
